import { render, staticRenderFns } from "./InternationalDisease.vue?vue&type=template&id=1dbd2024&scoped=true&"
import script from "./InternationalDisease.vue?vue&type=script&lang=js&"
export * from "./InternationalDisease.vue?vue&type=script&lang=js&"
import style0 from "./InternationalDisease.vue?vue&type=style&index=0&id=1dbd2024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd2024",
  null
  
)

export default component.exports